import React, { useState } from "react";
import { TASK_LABEL, TASKS_LABEL } from "./taskCopy";
import { VIEWER_READ_ONLY_MESSAGE } from "./orgPermissions";
import { projectTasksHome } from "./tasksHomeModel";
import TaskRow from "./TaskRow";
import "./TasksHome.css";

export default function TasksHomePage({
  repo,
  plans = [],
  reviewsByPlanId = {},
  loading = false,
  reviewsReady = true,
  mutateAllowed = false,
  archivingId = null,
  filter = "all",
  onNewTask,
  onOpenTask,
  onArchiveTask,
}) {
  const home = projectTasksHome({ repo, plans, reviewsByPlanId, loading, reviewsReady });
  const [openCompleted, setOpenCompleted] = useState(false);
  const isReviews = filter === "review";
  const visibleGroups = home.groups.filter((group) => {
    if (isReviews) return group.id === "readyToReview";
    return true;
  });

  return (
    <div
      className="tasks-home"
      data-testid="repository-mission-control"
      data-loading={home.loading ? "true" : "false"}
      data-reviews-ready={home.reviewsReady ? "true" : "false"}
    >
      <header className="tasks-home-header">
        <p className="tasks-home-kicker">{home.repoName}</p>
        <h2 id="mission-control-heading">
          {isReviews ? `Reviews for ${home.repoName}` : `${TASKS_LABEL} for ${home.repoName}`}
        </h2>
        <p data-testid="mission-briefing-observation">
          {isReviews
            ? "Work that already has delivered code and is ready for you to review. Paste a pull-request or branch link on the Task’s Delivered work tab, then open the review here."
            : "Plan work, hand it to engineering, and review what was delivered."}
        </p>
        {!isReviews && typeof onNewTask === "function" && mutateAllowed ? (
          <button type="button" className="founder-primary" onClick={onNewTask}>
            New {TASK_LABEL}
          </button>
        ) : null}
        {!mutateAllowed ? <p>{VIEWER_READ_ONLY_MESSAGE}</p> : null}
      </header>

      {home.loading ? (
        <p>Loading {TASKS_LABEL.toLowerCase()}…</p>
      ) : (
        visibleGroups.map((group) => {
          const collapsed = group.collapsedByDefault && !openCompleted;
          return (
            <section
              key={group.id}
              className="tasks-home-group"
              data-testid={`tasks-home-${group.id}`}
              aria-labelledby={`tasks-home-${group.id}-heading`}
            >
              <div className="tasks-home-group-head">
                <h3 id={`tasks-home-${group.id}-heading`}>
                  {group.title}
                  <span> {group.items.length}</span>
                </h3>
                <p>{group.hint}</p>
                {group.collapsedByDefault ? (
                  <button
                    type="button"
                    className="tasks-home-toggle"
                    onClick={() => setOpenCompleted((open) => !open)}
                  >
                    {collapsed ? "Show completed" : "Hide completed"}
                  </button>
                ) : null}
              </div>
              {collapsed ? null : group.items.length === 0 ? (
                <p className="tasks-home-empty">
                  {isReviews ? "Nothing is waiting for review." : "None right now."}
                </p>
              ) : (
                <div className="tasks-home-list" data-testid={group.id === "needsYou" ? "task-inbox-list" : undefined}>
                  {group.items.map((item) => (
                    <TaskRow
                      key={item.id}
                      item={item}
                      mutateAllowed={mutateAllowed}
                      archivingId={archivingId}
                      onOpen={onOpenTask}
                      onArchive={onArchiveTask}
                    />
                  ))}
                </div>
              )}
            </section>
          );
        })
      )}
    </div>
  );
}
